import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@mui/material';
import AppConfig from '../AppConfig';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
export default function XeroLink(props) {
    const { shortCode, size } = props;
    return (_jsx(ExternalLink, { link: AppConfig.xeroOrganisationPath + shortCode, label: "Xero", size: size }));
}
export function ExternalLink(props) {
    const { link, size, label } = props;
    return (_jsxs(Link, { style: { whiteSpace: 'nowrap', fontSize: size || '12px' }, target: "_blank", rel: "noopener noreferrer", href: link, children: [_jsx(OpenInNewIcon, { sx: { verticalAlign: 'middle', fontSize: size || '12px' } }), label] }));
}
